var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('NavBar'),_c('div',{staticClass:"sub_header_in sticky_header"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('lang.transfer.transfer')))])])]),_c('div',{staticClass:"container margin_60_35 pb-5"},[_c('TransferForm',{attrs:{"city":_vm.city,"store-id":_vm.storeId}})],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }